(function ($) {
  Drupal.behaviors.findYourMatchCarouselFormatterV1 = {
    attach: function (context) {
      var self = this;
      var $modules = $('.js-find-your-match-formatter-v1', context);

      // One time setup
      $modules.each(function () {
        var $module = $(this);
        var $pagination = $('.js-find-your-match-pagination', $module);
        var $thumbnailPlaceholder = $('.js-find-your-match-thumbnail-placeholder', $module);

        $thumbnailPlaceholder.each(function () {
          $pagination.append($(this).html());
        });
        $thumbnailPlaceholder.remove();
      });

      $(document).off('resize.responsive').on('resize.responsive', _.debounce(function () {
        self.attachFn($modules);
      }, 100));
      self.attachFn($modules);
    },

    attachFn: function ($modules) {
      var self = this;

      $modules.each(function () {
        self.initModule($(this));
      });
    },

    initModule: function ($module) {
      var inAccessibilityMode = false;
      var $carouselSlides = $('.js-find-your-match-slide', $module);
      var $pagination = $('.js-find-your-match-pagination', $module);
      var $pages = $('.js-find-your-match-thumbnail', $module);
      var isMobileWidth = Unison.fetch.now().name === 'small';
      var changePage = function (index) {
        if (!index) {
          index = 0;
        }
        if (!$pages.eq(index).length || $pages.eq(index).hasClass('active-look')) {
          return false;
        }
        $pages.removeClass('active-look');
        $pages.eq(index).addClass('active-look');
        $carouselSlides.hide();
        $carouselSlides.eq(index).fadeIn(400);
      };

      $pagination.slick({
        slidesToShow: $carouselSlides.length < 3 ? $carouselSlides.length : 3,
        infinite: false,
        variableWidth: $carouselSlides.length < 3,
        centerMode: $carouselSlides.length < 3,
        arrows: true,
        accessibility: true,
        onInit: function () {
          changePage();
          $pagination.addClass('matches-found--' + $carouselSlides.length);
        },
        onAfterChange: function (slider, index, nextIndex) {
          if (inAccessibilityMode || isMobileWidth) {
            var currentIndex = $pages.filter('.active-look').index();

            if (!nextIndex) {
              changePage(index);
            } else if (nextIndex > index) {
              changePage(++currentIndex);
            } else {
              changePage(--currentIndex);
            }
          }
        },
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              variableWidth: true,
              centerMode: false
            }
          }
        ]
      });
      // Make it scroll by one and show arrows if keyboard is used
      // This is a fix to our slick carousel accessibility issues
      $module.on('keyup.enableCenter', function (event) {
        if (event === 0) {
          return;
        }
        $module.off('keyup.enableCenter');
        $pagination.slickSetOption('slidesToShow', 1, false);
        $pagination.slickSetOption('variableWidth', true, true);
        inAccessibilityMode = true;
      });
      $('.js-find-your-match-link', $module).off('click.change').on('click.change', function (e) {
        e.preventDefault();
        // changePage($(this).parent().index());
      });
      $pages.off('click.change').on('click.change', function () {
        changePage($(this).index());
      });
      changePage();
    }
  };
})(jQuery);
